import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import { AppConstants, MarketingUserType } from "../../../common/APIConstants";
import React, { useEffect } from "react";
import moment from "moment";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import SmartSelect from "../../../common/SmartSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RestEndPoint from '../../../common/RestEndPoint';
import {
  DateTimeFormatter, DateFormatter
} from '../../../common/DateFormatterWithZone';
import {
  BooleanTextFormatter
} from '../../../common/BooleanFormatter';
import {
  faFileExport,
  faPlus,
  faSave,
  faSync,
  faAsterisk
} from "@fortawesome/free-solid-svg-icons";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import userRoles from '../../../constants/userRoles';
import '../component/sox-audit-screen-component.scss';
import { SOX_MARKETING_REP_GROUP_EMAIL } from "../../../constants/marketingRep";

@inject("MarketingRepUserStore", "AuthStore", "CommonStore")
@observer
class MarketingRepManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MarketingRepEmailID_old:'',
      AlternateUserEmailID_old:'',
      EscalationUser1EmailID_old:'',
      EscalationUser2AEmailID_old:'',
      EscalationUser2BEmailID_old:'',
      isAddMode: false,
      editRowData: '',
      isActive: false,
      isFormVisible: false,
      isDirectRoute: this.props.computedMatch.params.profile,
      formRowData: [],
      isSOXAuditAdminRole: false,
      isSOXAuditReportRole: false,
      rowSelected: false,
      gridOptions: {
        onRowDoubleClicked: this.viewScreen,
        suppressClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowSelection: "single",
        rowGroupPanelShow: "always",
        suppressContextMenu: true,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
        },
        frameworkComponents: {
          SmartSelect: SmartSelect,
          booleanCellEditor: CheckboxRenderer,
          dateTimeFormatter: DateTimeFormatter,
          dateFormatter: DateFormatter,
          booleanTextFormatter: BooleanTextFormatter,
        },
      },
    };
  }

  activeChange = (val, setFieldValue) => {
    const { currentTarget: {value} } = val
    const {
      MarketingRepEmailID_old, 
      AlternateUserEmailID_old,
      EscalationUser1EmailID_old,
      EscalationUser2AEmailID_old,
      EscalationUser2BEmailID_old,
    } = this.state

    if(value!=="true"){
      setFieldValue("MarketingRepEmailID", MarketingRepEmailID_old);
      setFieldValue("AlternateUserEmailID", AlternateUserEmailID_old);
      setFieldValue("EscalationUser1EmailID", EscalationUser1EmailID_old);
      setFieldValue("EscalationUser2AEmailID", EscalationUser2AEmailID_old);
      setFieldValue("EscalationUser2BEmailID", EscalationUser2BEmailID_old);
    }else {
      setFieldValue("MarketingRepEmailID", SOX_MARKETING_REP_GROUP_EMAIL);
      setFieldValue("AlternateUserEmailID", SOX_MARKETING_REP_GROUP_EMAIL);
      setFieldValue("EscalationUser1EmailID", SOX_MARKETING_REP_GROUP_EMAIL);
      setFieldValue("EscalationUser2AEmailID", SOX_MARKETING_REP_GROUP_EMAIL);
      setFieldValue("EscalationUser2BEmailID", SOX_MARKETING_REP_GROUP_EMAIL);
    }

    this.setState(prevState => ({isActive: !prevState.isActive}))
  }

  addNewRow = async () => {
    this.setState({ isFormVisible: true, formRowData: null, isAddMode: true });
  };
  closeForm = async () => {
    
    this.setState({ isFormVisible: false, formRowData: null, isAddMode: true, rowSelected: null });
    this.setState({ isViewMode: false });
    this.setState({ alternateContactSuggestions: [],escalationLevel1ContactSuggestions:[],escalationLevel2AContactSuggestions:[]});
  };
  editRow = async () => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ isFormVisible: true, formRowData: null, isAddMode: false, isActive: Boolean(selectedRow[0].IsActive) });
  };
  viewScreen = async () => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ rowSelected: selectedRow.length, editRowData: selectedRow[0], previousAcknowledgement: selectedRow[0]?.IsAcknowledged, isActive: Boolean(selectedRow[0].IsActive) });
    this.setState({ isViewMode: true });
    this.setState({ isFormVisible: true, formRowData: null, isAddMode: false });
  }
  onSelectionChanged = async () => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ rowSelected: selectedRow.length, editRowData: selectedRow[0], previousAcknowledgement: selectedRow[0]?.IsAcknowledged });
  };

  formSubmit(fields) {
    var current_fields = {
      ...fields,
      AlternateUser :(fields.AlternateUserEmailID!=''?fields.AlternateUser:''),
      EscalationUser1:(fields.EscalationUser1EmailID!=''?fields.EscalationUser1:''),
      EscalationUser2A:(fields.EscalationUser2AEmailID!=''?fields.EscalationUser2A:''),
      EscalationUser2B:(fields.EscalationUser2BEmailID!=''?fields.EscalationUser2B:''),
      MarketingRepName:(fields.MarketingRepEmailID!=''?fields.MarketingRepName:''),
    }

    this.saveScreenData(current_fields);
  }

  renderForm() {
    const { isAddMode, editRowData, primaryContactSuggestions, alternateContactSuggestions,
      escalationLevel1ContactSuggestions, escalationLevel2AContactSuggestions, escalationLevel2BContactSuggestions, isSOXAuditReportRole } = this.state;
    const { MarketingRepUserStore } = this.props;
    const { isActive } = this.state
    const validationSchema = Yup.object().shape({
      MarketingRepID: Yup.string().required("Marketing RepID is required").nullable(),
      MarketingRepName: Yup.string().required("Marketing Rep Name is required").nullable(),
      EscalationUser1: Yup.string().required("Escalation User 1 is required").nullable(),
      EscalationUser2A: Yup.string().required("Escalation User 2A is required").nullable(),
      MarketingRepEmailID: Yup.string().required("Marketing Rep Email is required").nullable(),
      EscalationUser1EmailID: Yup.string().required("Escalation User 1 Email is required").nullable(),
      EscalationUser2AEmailID: Yup.string().required("Escalation User 2A Email is required").nullable(),
    });
    
    return (
      <Formik
        initialValues={MarketingRepUserStore.initialValues}
        validationSchema={validationSchema}
        //onSubmit={(fields) => { this.saveScreenData(fields); }}
        onSubmit={(fields) => { this.formSubmit(fields); }}
      >
        {({ errors, touched, isSubmitting, setFieldValue }) => {
          useEffect(() => {
            if (!isAddMode) {
              const selectedRow = editRowData;
              const fields = MarketingRepUserStore.fields;
              fields.forEach((field) =>{
                  setFieldValue(field, selectedRow[field], false)

                  /* 
                    MarketingRepEmailID
                    AlternateUserEmailID
                    EscalationUser1EmailID
                    EscalationUser2AEmailID
                    EscalationUser2BEmailID

                  */

                  switch(field){
                    case 'MarketingRepEmailID':
                      if(selectedRow[field]!='MktgRepSOXPriceAudit@paalp.com')
                        this.setState({ MarketingRepEmailID_old: selectedRow[field] });
                    break;

                    case 'AlternateUserEmailID':
                      if(selectedRow[field]!='MktgRepSOXPriceAudit@paalp.com')
                        this.setState({ AlternateUserEmailID_old: selectedRow[field] });
                    break;

                    case 'EscalationUser1EmailID':
                      if(selectedRow[field]!='MktgRepSOXPriceAudit@paalp.com')
                        this.setState({ EscalationUser1EmailID_old: selectedRow[field] });
                    break;

                    case 'EscalationUser2AEmailID':
                      if(selectedRow[field]!='MktgRepSOXPriceAudit@paalp.com')  
                        this.setState({ EscalationUser2AEmailID_old: selectedRow[field] });
                    break;

                    case 'EscalationUser2BEmailID':
                      if(selectedRow[field]!='MktgRepSOXPriceAudit@paalp.com')
                        this.setState({ EscalationUser2BEmailID_old: selectedRow[field] });
                    break;
                  }
                }
              );
            }
          }, [setFieldValue]);
          return (
            <Form>
              <div className="row">
                <div className=" col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Marketing Rep Name<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="MarketingRepName"
                          type="text"
                          className={
                            "form-control" +
                            (errors.MarketingRepName && touched.MarketingRepName ? " is-invalid" : "")
                          }
                          onChange={(val) => { // val <-- synthetic event
                            // get rid of synthetic event warning by destructing the value from currentTarget
                            const { currentTarget: {value} } = val
                            setFieldValue("MarketingRepEmailID", "")
                            this.loadSuggestion(val, "primary")
                            .then(setFieldValue("MarketingRepName", value)); 
                          }}
                          //disabled={!isAddMode}
                          disabled={this.state.isSOXAuditAdminRole?false:(isAddMode)}
                        />
                        <ul className="suggestions">
                          {primaryContactSuggestions && primaryContactSuggestions.map((suggestion) => {
                            return (
                              <li 
                                key={suggestion.id}
                                onClick={() => {
                                  setFieldValue("MarketingRepName", suggestion.displayName);
                                  setFieldValue("EscalationUser1", suggestion.manager.displayName);
                                    setFieldValue("MarketingRepEmailID", isActive ? suggestion.mail : SOX_MARKETING_REP_GROUP_EMAIL);
                                    setFieldValue("EscalationUser1EmailID", isActive ? suggestion.manager.mail : SOX_MARKETING_REP_GROUP_EMAIL);
                                  this.setEscalationUsers(suggestion.manager.userPrincipalName,setFieldValue);
                                  this.setState({ primaryContactSuggestions: [] });
                                }}
                              >
                                {suggestion.displayName}
                              </li>
                            );
                          })}
                        </ul>
                        <ErrorMessage
                          name="MarketingRepName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Marketing Rep Email<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="MarketingRepEmailID"
                          type="text"
                          className={
                            "form-control" +
                            (errors.MarketingRepEmailID && touched.MarketingRepEmailID ? " is-invalid" : "")
                          }
                          disabled={true}
                        />
                        <ErrorMessage
                          name="MarketingRepEmailID"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Alternate User</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="AlternateUser"
                          type="text"
                          className={
                            "form-control" +
                            (errors.AlternateUser && touched.AlternateUser ? " is-invalid" : "")
                          }
                          onChange={(val) => { // val <-- synthetic event
                            // get rid of synthetic event warning by destructing the value from currentTarget
                            const { currentTarget: {value} } = val
                            setFieldValue("AlternateUserEmailID", '')
                            setFieldValue("AlternateUser", value)
                            this.loadSuggestion(val, "alternate")
                            .then(()=>{
                              if(value!=="" || typeof (value)==='undefined' ){
                                setFieldValue("AlternateUserEmailID", '')
                              }  
                            }); 
                          }}
                        />
                        <ul className="suggestions">
                          {alternateContactSuggestions && alternateContactSuggestions.map((suggestion) => {
                            return (
                              <li
                                key={suggestion.id}
                                onClick={() => {
                                  setFieldValue("AlternateUser", suggestion.displayName);
                                  setFieldValue("AlternateUserEmailID", isActive ? suggestion.mail: SOX_MARKETING_REP_GROUP_EMAIL);
                                  this.setState({ alternateContactSuggestions: [] });
                                }}
                              >
                                {suggestion.displayName}
                              </li>
                            );
                          })}
                        </ul>
                        <ErrorMessage
                          name="AlternateUser"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Alternate User Email</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="AlternateUserEmailID"
                          type="text"
                          className={
                            "form-control" +
                            (errors.AlternateUserEmailID && touched.AlternateUserEmailID ? " is-invalid" : "")
                          }
                          disabled={true}
                        />
                        <ErrorMessage
                          name="AlternateUserEmailID"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Escalation User 1<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EscalationUser1"
                          type="text"
                          className={
                            "form-control" +
                            (errors.EscalationUser1 && touched.EscalationUser1 ? " is-invalid" : "")
                          }
                          
                          onChange={(val) => { // val <-- synthetic event
                              // get rid of synthetic event warning by destructing the value from currentTarget
                              const { currentTarget: {value} } = val
                              setFieldValue("EscalationUser1EmailID", '')
                              setFieldValue("EscalationUser1", value)
                              this.loadSuggestion(val, "escalationlevel1")
                              .then(()=>{
                                if(value ==='' || typeof (value)==='undefined' ){
                                  setFieldValue("EscalationUser1EmailID", '')
                                }  
                              });
                          }}
                        
                        />
                        <ul className="suggestions">
                          {escalationLevel1ContactSuggestions && escalationLevel1ContactSuggestions.map((suggestion) => {
                            return (
                              <li 
                                key={suggestion.id}
                                onClick={() => {
                                setFieldValue("EscalationUser1", suggestion.displayName);
                                setFieldValue("EscalationUser1EmailID", isActive ? suggestion.mail : SOX_MARKETING_REP_GROUP_EMAIL);
                                this.setEscalationUsers(suggestion.userPrincipalName,setFieldValue);
                                this.setState({ escalationLevel1ContactSuggestions: [] });
                              }}
                              >
                                {suggestion.displayName}
                              </li>
                            );
                          })}
                        </ul>
                        <ErrorMessage
                          name="EscalationUser1"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Escalation Level1 Email<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EscalationUser1EmailID"
                          type="text"
                          className={
                            "form-control" +
                            (errors.EscalationUser1EmailID && touched.EscalationUser1EmailID ? " is-invalid" : "")
                          }
                          disabled={true}
                        />
                        <ErrorMessage
                          name="EscalationUser1EmailID"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Escalation User 2A<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EscalationUser2A"
                          type="text"
                          className={
                            "form-control" +
                            (errors.EscalationUser2A && touched.EscalationUser2A ? " is-invalid" : "")
                          }
                          
                          onChange={(val) => { // val <-- synthetic event
                              // get rid of synthetic event warning by destructing the value from currentTarget
                              const { currentTarget: {value} } = val 
                              setFieldValue("EscalationUser2AEmailID", '')
                              setFieldValue("EscalationUser2A", value)
                              this.loadSuggestion(val, "escalationlevel2A")
                              .then(()=>{
                                if(value ==='' || typeof (value)==='undefined' ){
                                  setFieldValue("EscalationUser2AEmailID", '')
                                }  
                              }); 
                          }}
                        
                        />
                        <ul className="suggestions">
                          {escalationLevel2AContactSuggestions && escalationLevel2AContactSuggestions.map((suggestion) => {
                            return (
                              <li 
                                key={suggestion.id}
                                onClick={() => {
                                setFieldValue("EscalationUser2A", suggestion.displayName);
                                setFieldValue("EscalationUser2AEmailID", isActive ? suggestion.mail : SOX_MARKETING_REP_GROUP_EMAIL);
                                this.setState({ escalationLevel2AContactSuggestions: [] });
                              }}
                              >
                                {suggestion.displayName}
                              </li>
                            );
                          })}
                        </ul>
                        <ErrorMessage
                          name="EscalationUser2A"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Escalation Level2A Email<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EscalationUser2AEmailID"
                          type="text"
                          className={
                            "form-control" +
                            (errors.EscalationUser2AEmailID && touched.EscalationUser2AEmailID ? " is-invalid" : "")
                          }
                          disabled={true}
                        />
                        <ErrorMessage
                          name="EscalationUser2AEmailID"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Escalation User 2B<span className="otg-reqicon"></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EscalationUser2B"
                          type="text"
                          className={
                            "form-control" +
                            (errors.EscalationUser2B && touched.EscalationUser2B ? " is-invalid" : "")
                          }
                          onChange={(val) => { // val <-- synthetic event
                              // get rid of synthetic event warning by destructing the value from currentTarget
                              const { currentTarget: {value} } = val
                              setFieldValue("EscalationUser2BEmailID", '')
                              setFieldValue("EscalationUser2B", value)
                              this.loadSuggestion(val, "escalationlevel2B")
                              .then(()=>{
                                if(value ==='' || typeof (value)==='undefined' ){
                                  setFieldValue("EscalationUser2BEmailID", '')
                                }  
                              }); 
                          }}
                        />
                        <ul className="suggestions">
                          {escalationLevel2BContactSuggestions && escalationLevel2BContactSuggestions.map((suggestion) => {
                            return (
                              <li 
                                key={suggestion.id}
                                onClick={() => {
                                  setFieldValue("EscalationUser2B", suggestion.displayName);
                                  setFieldValue("EscalationUser2BEmailID", isActive ? suggestion.mail : SOX_MARKETING_REP_GROUP_EMAIL);
                                  this.setState({ escalationLevel2BContactSuggestions: [] });
                                }}
                              >
                                {suggestion.displayName}
                              </li>
                            );
                          })}
                        </ul>
                        <ErrorMessage
                          name="EscalationUser2B"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Escalation Level2B Email<span className="otg-reqicon"></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EscalationUser2BEmailID"
                          type="text"
                          className={
                            "form-control" +
                            (errors.EscalationUser2BEmailID && touched.EscalationUser2BEmailID ? " is-invalid" : "")
                          }
                          disabled={true}
                        />
                        <ErrorMessage
                          name="EscalationUser2BEmailID"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Marketing Rep ID<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="MarketingRepID"
                          type="number"
                          className={
                            "form-control" +
                            (errors.MarketingRepID && touched.MarketingRepID ? " is-invalid" : "")
                          }
                          disabled={!isAddMode}
                        />
                        <ErrorMessage
                          name="MarketingRepID"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-md-6">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Is Active</label>
                      </div>
                      <div className=" col-md-9">
                        <Field 
                          name="IsActive"
                          component="input"
                          type="checkbox"
                          onClick={(val) => this.activeChange(val, setFieldValue)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group btnotg-pos">
                <button
                  type="submit"
                  disabled={isSubmitting || isSOXAuditReportRole}
                  className="btn btn-primary controlotg-btns"
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  Save
                </button>

                <button
                  type="cancel"
                  disabled={isSubmitting}
                  className="btn btn-primary controlotg-btns"
                  onClick={this.closeForm}
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  Cancel
                </button>
              </div>

            </Form>
          );
        }}
      </Formik>
    );
  }

  render() {
    const {
      addRowBtnText,
      editBtnText,
      exportBtnText,
      refreshBtnText,
    } = this.props.MarketingRepUserStore;
    const {
      screen: { title },
    } = this.getCurrentScreen();
    const { columnDefinitions, rowData } =
      this.props.MarketingRepUserStore;
    const { isFormVisible, rowSelected, isSOXAuditAdminRole, isSOXAuditReportRole } = this.state;
    let colDef = [...columnDefinitions];
    return (
      <div className="col-md-12">
        <div className="container cb-title-container">
          <h3 className="cb-title">{title}</h3>
        </div>
        {!isFormVisible && (
          <div className="outage-grid-div">
            <>
              <div className="row">
                <AgGrid
                  gridOptions={this.state.gridOptions}
                  columnDefs={colDef}
                  rowData={rowData}
                  onSelectionChanged={this.onSelectionChanged}
                  onFilterChanged={this.onFilterChanged}
                  rememberGroupStateWhenNewData={true}
                />
              </div>

              <div className="row btn-toolbar pull-right">
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.addNewRow}
                  disabled={!isSOXAuditAdminRole || isSOXAuditReportRole}
                >
                  <FontAwesomeIcon icon={faPlus} /> {addRowBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  disabled={!rowSelected || !isSOXAuditAdminRole || isSOXAuditReportRole}
                  onClick={this.editRow}
                >
                  <FontAwesomeIcon icon={faSave} /> {editBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.exportToExcel}
                >
                  <FontAwesomeIcon icon={faFileExport} /> {exportBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.refreshData}
                >
                  <FontAwesomeIcon icon={faSync} /> {refreshBtnText}
                </button>
              </div>
            </>
          </div>
        )}
        {isFormVisible && isSOXAuditAdminRole && (
          <div className="otg-formoutlay">{this.renderForm()}</div>
        )}
      </div>
    );
  }

  

  componentWillMount = async () => {
    const { CommonStore } = this.props;
    
    if(!CommonStore.screenDetails.length)
    await CommonStore.getScreens();

    if (this.state.isDirectRoute) {
      CommonStore.toggleLoader();
      CommonStore.getScreens().then(() => {
        CommonStore.toggleLoader();
        this.refreshData();
      }).catch(() => {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
        CommonStore.toggleLoader();
      })
    }
    await this.refreshData();
  };

  exportToExcel = () => {
    const currentScreen = this.getCurrentScreen();
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet = currentScreen.screen.title.split(' ').join('_');
    let fileNameExcelExport = currentSheet + '_Export_All_' + formattedDate + '';
    this.state.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
      columnKeys: this.generateColumnsForCustomExcel(),
      processCellCallback: function (params) {
        if (params.column.colDef.cellRenderer === "booleanTextFormatter") {
          var value = params.value;
          return (value && value === true) ? "Yes" : "No";
        }
        return params.value;
      }
    })
  };
  generateColumnsForCustomExcel() {
    this.state.gridOptions.columnApi.getAllDisplayedColumns().map(column => column.getColId());
  }
  getCurrentScreen = () => {
    var screenName = this.props.path.split("/").pop();
    const { isDirectRoute } = this.state;
    if (isDirectRoute) {
      screenName = this.props.path.split("/")[1];
    }
    var currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    if (!currentScreen) {
      return {
        screen: { title: '', canEditRow: '', canCopyRow: '', canDeleteRow: '' },
        exportProfiles: '',
      }

    }
    return currentScreen;
  };

  loadSuggestion = async (target, controlName) => {
    const val = target.currentTarget.value.trim();
    if (val.length >= 3) {
      var users = await RestEndPoint.getUsers(val);
      if (users && users.data && users.data.value && users.data.value.length > 0) {
        switch (controlName) {
          case MarketingUserType.PRIMARY:
            this.setState({ primaryContactSuggestions: users.data.value });
            break;
          case MarketingUserType.ALTERNATE:
            this.setState({ alternateContactSuggestions: users.data.value });
            break;
          case MarketingUserType.ESCALATIONLEVEL1:
            this.setState({ escalationLevel1ContactSuggestions: users.data.value });
            break;
          case MarketingUserType.ESCALATIONLEVEL2A:
            this.setState({ escalationLevel2AContactSuggestions: users.data.value });
            break;
          case MarketingUserType.ESCALATIONLEVEL2B:
            this.setState({ escalationLevel2BContactSuggestions: users.data.value });
            break;  
          default :
            this.setState({ primaryContactSuggestions: users.data.value });
            break;
        }
      }
    }
  }

  setEscalationUsers = async (userPrincipalName,setFieldValue) => {
    const { isActive } = this.state
    var EscalationUser = await RestEndPoint.getManager(userPrincipalName);
    setFieldValue("EscalationUser2A", EscalationUser.data.displayName);
    setFieldValue("EscalationUser2AEmailID", isActive ? EscalationUser.data.mail : SOX_MARKETING_REP_GROUP_EMAIL);
  }

  refreshData = async () => {
    await this.getScreenData();
    await this.getInitialValues();
    
    if (this.state.gridOptions && this.state.gridOptions.api) {
      this.state.gridOptions.api.deselectAll();
    }
  };
  getInitialValues = async () => {
    const { MarketingRepUserStore } = this.props;
    await MarketingRepUserStore.getInitialValues();
    
  };

  getScreenData = async () => {
    const { isDirectRoute } = this.state;
    const { CommonStore, MarketingRepUserStore } = this.props;
    const currentScreen = this.getCurrentScreen();
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN'); // This is the json string we stored
    const roleObj = JSON.parse(jsonStringOBJ);

    if (currentScreen.screen.title && !isDirectRoute) {
      await MarketingRepUserStore.getScreenData(currentScreen, CommonStore);
      if (roleObj && roleObj.roles) {
        const roles = roleObj.roles.join();
        const isSOXAuditAdminRole = (roles.indexOf(userRoles.SOXAUDITPRICINGADMIN) !== -1);
        const isSOXAuditReportRole = (roles.indexOf(userRoles.SOXAUDITREPORTROLE) !== -1)
        if (isSOXAuditAdminRole) {
          this.setState({ isSOXAuditAdminRole: true })
        }
        if (isSOXAuditReportRole) {
          this.setState({ isSOXAuditReportRole: true })
        }
      }
    }
    this.setState({ rowSelected: true, isAddMode: false, isFormVisible: false });
  }

  saveScreenData = async (screenData) => {
    const { CommonStore, MarketingRepUserStore } = this.props;
    const { isAddMode } = this.state;
    this.populateAuditFields(screenData, isAddMode);
    const currentScreen = this.getCurrentScreen();
    const saveMode = isAddMode ? "Save" : "Update";
    await MarketingRepUserStore.saveScreenData(
      screenData,
      CommonStore,
      currentScreen,
      saveMode
    );
    this.setState({ isAddMode: false });
    this.closeForm();
    await this.refreshData();
  };

  populateAuditFields(data, isAddRow) {
    const currentUser = RestEndPoint.getCurrentUserName();
    const currentUserEmail = RestEndPoint.getCurrentUserEmail();
    var currentTime = moment(new Date());
    if ('CreatedBy' in data && isAddRow) {
      data['CreatedBy'] = currentUser;
    }
    if ('UpdatedBy' in data) {
      data['UpdatedBy'] = currentUser;
    }
    if ('CreatedOn' in data && isAddRow) {
      data['CreatedOn'] = currentTime;
    }
    if ('CreatedEmail' in data && isAddRow) {
      data['CreatedEmail'] = currentUserEmail;
    }
    if ('UpdatedOn' in data) {
      data['UpdatedOn'] = currentTime;
    }
  }
}

export default MarketingRepManagement;
